module.exports = __webpack_public_path__ + "img/117.5e6c067a.jpg";